import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "graphql-tag";
import { newList } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { useAdminSubmit } from "../shared/use-admin-submit";
import ListsForm, { InterestList } from "./form";

const CREATE_LIST = gql`
  mutation newList($data: InterestListInput!) {
    createInterestList(data: $data) {
      id
    }
  }
`;

const initialData = {
  organizationId: "",
  name: "",
  type: "",
  email: "",
  phone: "",
  hasPaperDisclaimer: false,
  address: {
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  },
};


const NewList: React.FC = () => {
  const { sending, submit } = useAdminSubmit("/dash/admin/lists");
  const [createInterestList] = useMutation<newList>(CREATE_LIST);
  const submitForm = (formData: InterestList) =>
    submit(() => createInterestList({ variables: { data: formData } }));
  return (
    <div className="card">
      <AdminHeading component="h1">Create a List</AdminHeading>

      <ListsForm
        formType="new"
        initialData={initialData}
        sending={sending}
        handleSubmit={submitForm}
      />
    </div>);
};

export default NewList;
